import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../config.service';
import {
  ProductoModel,
  ImagenesArticulo,
  Stock,
} from '../../models/producto/producto.model';
import { EquivalenteModel } from '../../models/producto/equivalente.model';
import { AplicacionModel } from '../../models/producto/aplicacion.model';
import {
  ImagenModel,
  Data as DataImg,
} from '../../models/producto/imagen.model';
import { NroPiezaModel } from '../../models/producto/nro-pieza.model';
import { catchError, elementAt, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ParametroModel } from '../../models/producto/parametro.model';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProductoService {
  private baseUrl = this.configService.config.servidor?.api_server;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private authService: AuthService
  ) {}

  getProductos(params: any) {
    // const url = `${this.baseUrl}/Articulo`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ARTICULO.VERSION + this.configService.resource.ARTICULO.PATH_BASE;
    // params.idPlataforma = this.plataforma;
    const httpParams = new HttpParams(params);
    return this.http.get<ProductoModel>(url, { params: params }).pipe(
      map((resp: ProductoModel) => {
        if (resp.Data) {
          let skus = '';
          resp.Data.forEach((product) => {
            skus = skus + product.Articulo.Codigo + ',';
            product.Articulo.Stock.CantidadFisica = this.mapStock(
            product.Articulo.Stock
            );
          });
          let imagenes = undefined;
          this.getImagenesArticulo(skus).subscribe(img => {
            imagenes = img;
            resp.Data.forEach((element) => {
              let img: ImagenesArticulo = {
                Imagen: 'assets/images/productos/default.png',
                Orden: 1,
              };
              if (imagenes[element.Articulo.Codigo].length > 0) {
                img.Imagen = imagenes[element.Articulo.Codigo][0];
              }
        
            element.Articulo.ImagenesArticulo.push(img);
  
              // let stock = parseFloat(element.stock.replace(/,/g, "."));
              // let min = parseFloat(element.cantidad_minima.replace(/,/g, "."));
              
              // element.stock = stock;
              // element.cantidad_minima = min;
            });
          });
     
        }

        return resp;
      })
    );
  }

  getEquivalentes(tipo_relacion: string, id_articulo: number, codigo: string) {
    // const url = `${this.baseUrl}/ArticuloEquivalencia`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ARTICULO_EQUIVALENCIA.VERSION + this.configService.resource.ARTICULO_EQUIVALENCIA.PATH_BASE;
    let params = {};

    {
      Object.assign(params, { IdArticulo: id_articulo });
    }
    {
      Object.assign(params, { TipoRelacion: tipo_relacion });
    }

    return this.http.get<EquivalenteModel>(url, { params });
    // .pipe(
    //   map((resp: EquivalenteModel) => {
    //     if(resp.Data)
    //     resp.forEach(element => {
    //       if(element.codigo_ao == codigo){
    //         element.codigo_ao = element.codigo_ad;
    //         element.articulo_o = element.articulo_d;
    //       }
    //     });
    //     return resp;
    //   })
    // );
  }

  getAplicaciones(id_articulo: number) {
    // const url = `${this.baseUrl}/ArticuloAplicacion`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ARTICULO_APLICACION.VERSION + this.configService.resource.ARTICULO_APLICACION.PATH_BASE;
    let params = {};
    {
      Object.assign(params, { idArticulo: id_articulo });
    }
    {
      Object.assign(params, { PageNumber: 0 });
    }

    return this.http.get<AplicacionModel>(url, { params });
  }

  // SC CATFER-84 se redefine para utilizar la obtencion de las imagenes de la API FERRETTI.
  getImagenesArticulo(sku: string) {
    const url = `${this.configService.config.servidor!.images_server}/product_images.php`;
    const params = {
      sku: sku
    };

    return this.http.get<any>(url, { params })
  }


  mapImagenPath(imagen: string) {
    const urlImagen = this.configService.config.servidor!.images_server;
    if (imagen != '') {
      imagen = `${urlImagen}/` + imagen;
    } else {
      imagen = 'assets/images/productos/default.png';
    }
    return imagen;
  }
  mapStock(stock: Stock) {
    const stock_disponible =
      this.configService.config.productos?.stock_disponible;
    let stock_calculado: number = stock.CantidadFisica;
    if (stock_disponible === 1 || stock_disponible === 2) {
      // const stock_comprometido = parseFloat(comprometido.replace(/,/g, "."));

      stock_calculado = stock.CantidadFisica - stock.CantidadComprometida;
      if (stock_disponible === 2) {
        // const stock_reservado = parseFloat(reservado.replace(/,/g, "."));
        stock_calculado = stock_calculado - stock.CantidadReservada;
      }
    }
    return stock_calculado;
  }

  deleteProduct() {
    return this.http.delete(`${this.baseUrl}/api/Productoes/39`).pipe(
      catchError((err) => {
        return of(err);
      })
    );
  }

  getNroPieza(id_articulo: number) {
    // const url = `${this.baseUrl}/ArticuloNroPieza`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.ARTICULO_NRO_PIEZA.VERSION + this.configService.resource.ARTICULO_NRO_PIEZA.PATH_BASE;
    const params = {
      id_articulo: id_articulo,
      Plataforma: 2,
    };

    return this.http.get<NroPiezaModel>(url, { params });
  }
}
